import { useEffect } from 'react';
import {
  useDeleteTrainingDocMutation,
  useDeleteTrainingLogMutation,
  useGetTariningLogDataQuery,
  useLazyCreateTrainingLogQuery,
  useLazyGetPageLevelSignDataQuery,
  useLazyUpdatePageLevelSignatureQuery,
  useUpdateTrainingLogMutation,
  useUpdateTrainingLogSignatureMutation
} from 'src/services/TrainingLog';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { hideLoader, showLoader } from 'src/store/Loader';
import { updateUserAccess } from 'src/util/util';

export const useTrainingLogServices = () => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const country = useAppSelector(state => state.site.selectedCountry);
  const siteId = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;
  const dispatch = useAppDispatch();

  const {
    isLoading: getTrainingLogLoading,
    isError: getTrainingLogIsError,
    isSuccess: getTrainingLogIsSuccess,
    data: trainingLogQueryData,
    error: getTrainingLogError,
    refetch: getTrainingLogQueryData
  } = useGetTariningLogDataQuery({
    site_id: siteId,
    study_id: studyId,
    country,
    application
  });

  const [
    updateTrainingLogSign,
    {
      isLoading: updateTrainingLogSignLoading,
      isError: updateTrainingLogSignIsError,
      isSuccess: updateTrainingLogSignIsSuccess,
      data: updateTrainingLogSignData,
      error: updateTrainingLogSignError
    }
  ] = useUpdateTrainingLogSignatureMutation();
  const [
    getPageLevelSignData,
    {
      isLoading: pageLevelSignDataLoading,
      isError: pageLevelSignDataIsError,
      data: pageLevelSignData,
      error: pageLevelSignDataError,
      isSuccess: pageLevelSignDataIsSuccess
    }
  ] = useLazyGetPageLevelSignDataQuery();
  const [
    updatePageLevelSignature,
    {
      isLoading: updatePageLevelSignLoading,
      isError: updatePageLevelSignIsError,
      data: updatePageLevelSignData,
      error: updatePageLevelSignError,
      isSuccess: updatePageLevelSignIsSuccess
    }
  ] = useLazyUpdatePageLevelSignatureQuery();
  const [
    updateTrainingLog,
    {
      isLoading: updateTrainingLogLoading,
      isError: updateTrainingLogIsError,
      data: updateTrainingLogData,
      error: updateTrainingLogError,
      isSuccess: updateTrainingLogIsSuccess
    }
  ] = useUpdateTrainingLogMutation();

  const [
    createTrainingLog,
    {
      isLoading: createTrainingLogLoading,
      isError: createTrainingLogIsError,
      data: createTrainingLogData,
      error: createTrainingLogError,
      isSuccess: createTrainingLogIsSuccess
    }
  ] = useLazyCreateTrainingLogQuery();

  const [
    deleteTrainingDoc,
    {
      isLoading: deleteTrainingDocLoading,
      isError: deleteTrainingDocIsError,
      data: deleteTrainingDocData,
      error: deleteTrainingDocError,
      isSuccess: deleteTrainingDocIsSuccess
    }
  ] = useDeleteTrainingDocMutation();

  const [
    deleteTrainingLog,
    {
      isLoading: deleteTrainingLogLoading,
      isError: deleteTrainingLogIsError,
      data: deleteTrainingLogData,
      error: deleteTrainingLogError
    }
  ] = useDeleteTrainingLogMutation();

  useEffect(() => {
    if (
      updateTrainingLogSignLoading ||
      pageLevelSignDataLoading ||
      updatePageLevelSignLoading ||
      updateTrainingLogLoading ||
      createTrainingLogLoading ||
      deleteTrainingDocLoading ||
      deleteTrainingLogLoading
    ) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [
    updateTrainingLogSignLoading,
    pageLevelSignDataLoading,
    updatePageLevelSignLoading,
    updateTrainingLogLoading,
    createTrainingLogLoading,
    deleteTrainingDocLoading,
    deleteTrainingLogLoading
  ]);

  useEffect(() => {
    if (
      updateTrainingLogSignError ||
      getTrainingLogError ||
      updateTrainingLogError ||
      createTrainingLogError ||
      deleteTrainingDocError ||
      deleteTrainingLogError
    ) {
      updateUserAccess(
        updateTrainingLogSignError ||
          getTrainingLogError ||
          updateTrainingLogError ||
          createTrainingLogError ||
          deleteTrainingDocError ||
          deleteTrainingLogError,
        dispatch
      );
    }
  }, [
    updateTrainingLogSignError,
    getTrainingLogError,
    updateTrainingLogError,
    createTrainingLogError,
    deleteTrainingDocError,
    deleteTrainingLogError
  ]);

  return {
    getTrainingLogIsSuccess,
    updateTrainingLogSignLoading,
    updateTrainingLogSignIsError,
    updateTrainingLogSignIsSuccess,
    updateTrainingLogIsError,
    updateTrainingLogData,
    updateTrainingLogIsSuccess,
    createTrainingLogIsError,
    createTrainingLogData,
    createTrainingLogIsSuccess,
    deleteTrainingDocLoading,
    deleteTrainingDocIsError,
    deleteTrainingDocData,
    deleteTrainingDocIsSuccess,
    deleteTrainingLogLoading,
    deleteTrainingLogIsError,
    deleteTrainingLogData,
    getTrainingLogLoading,
    trainingLogQueryData,
    getTrainingLogIsError,
    getTrainingLogError,
    getTrainingLogQueryData,
    updateTrainingLogSignError,
    updateTrainingLogSign,
    pageLevelSignData,
    getPageLevelSignData,
    pageLevelSignDataLoading,
    pageLevelSignDataIsError,
    pageLevelSignDataError,
    pageLevelSignDataIsSuccess,
    updatePageLevelSignLoading,
    updatePageLevelSignIsError,
    updatePageLevelSignData,
    updatePageLevelSignError,
    updatePageLevelSignIsSuccess,
    updatePageLevelSignature,
    updateTrainingLogSignData,
    updateTrainingLogLoading,
    updateTrainingLog,
    createTrainingLogLoading,
    createTrainingLog,
    deleteTrainingDoc,
    deleteTrainingLog
  };
};
